<template>
	<div class="allback">
		<div class="zy_content content-nav">
			<img src="@/images/nav_img.png" /> 
			<span>在线直播</span><i class="el-icon-arrow-right"></i>&nbsp;<span>直播列表</span>
		</div>
		<el-container class="content">
			<div class=" zy_content clearfix">
				<div class="zy_index_title">
					<img src="@/images/title_back1.png" class="zy_index_titleback" />
					<img src="@/images/zy-title6.png" class="zy_index_titlename" />
					<div class="zy_index_titleright clearfix">
						<div class="zy_index_titlerightitem" :class="typeId == null?'active':''" @click="typeChange(null)">
							<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
							<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
							<div class="zy_index_titlerightinfo">全部</div>
						</div>
						<div class="zy_index_titlerightitem" :class="item.id == typeId?'active':''" v-for="(item, index) in typeList" :key="'type' + index" @click="typeChange(item.id)">
							<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
							<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
							<div class="zy_index_titlerightinfo text-ellipsis">{{item.name}}</div>
						</div>
					</div>
				</div>
				<div class="zy_maincont clearfix">
					<div v-if="!livelist || livelist.length<=0" class="simulation_empty_msg_content">暂无直播</div>
					<div class="clearfix" v-if="livelist && livelist.length>0">
						<div class="zy_liveitem " v-for="(item,index) in livelist" @click="tolive(item)">
							<div class="live_img">
								<div class="live_status">
									<span class="ing" v-show="item.state == 1">·</span>
									<span v-show="item.state == 0">未开播</span>
									<span v-show="item.state == 1">已开播</span>
									<span v-show="item.state == 2">已结束</span>
								</div>
								<div class="box blury-card">
									<img :src="baseurl + item.roomPic" class="live_img1" />
									<div class="frame">
										<h2>Live online</h2>
										<p></p>
									</div>
								</div>
							</div>
							<div class="zy_liveinfo">
								<p class="zy_liveinfoP1">{{item.roomName}}
								</p>
								<p class="zy_liveinfoP2">
									主讲人：<span>{{item.name}}</span>
								</p>
								<p class="zy_liveinfoP2">
									直播时间：<span>{{item.startTime | parseTime('{m}-{d} {h}:{i}')}}-{{item.endTime | parseTime('{m}-{d} {h}:{i}')}}</span>
								</p>
							</div>
						</div>
					</div>
					<div class="all_live_page" v-if="livelist && livelist.length>0">
						<el-pagination background @current-change="currentChange" :current-page="livePage" :page-size="pageSize" layout=" prev, pager, next" :total="liveRow">
						</el-pagination>
					</div>
				</div>
			</div>
		</el-container>
	</div>
</template>

<script>
	import { getLiveList } from '@/api/live.js'
	export default {
		name: 'live',
		data() {
			return {
				livePage: 1,
				liveRow: 0,
				pageSize: 8,
				livelist: [],
				typeId: null,
				typeList: [{
					id: '1',
					name: '已开播'
				}, {
					id: '0',
					name: '未开播'
				},{
					id: '2',
					name: '已结束'
				}],
			}
		},
		created() {
			this.getLive();
		},
		mounted() {},
		methods: {
			tolive(item) {
				var data = {
					roomId: item.roomId
				}
				if(item.state == '0') {
					this.$alert('直播未开始，请稍候', '提示', {
						confirmButtonText: '确定',
						type: 'warning'
					})
				}
				if(item.state == '1') {
					this.$router.push({
						name: 'live',
						query: {
							roomId: item.roomId
						}
					})
				}
				if(item.state == '2') {
					this.$router.push({
						name: 'indexover',
						query: {
							roomId: item.roomId
						}
					})
				}
			},
			currentChange(livePage) {
				this.livePage = livePage;
				this.getLive();
			},
			typeChange(id) {
				this.typeId = id;
				this.getLive();
			},
			getLive() {
				var data = {
					page: this.livePage,
					pageSize: this.pageSize,
					state: this.typeId,
				}
				getLiveList(data).then(res => {
					this.livelist = res.data.listData;
					this.liveRow = res.data.totalRow;
				})
			},
		},
		beforeRouteLeave(to, from, next) {
			next();
		},
	}
</script>